import React from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

/**
 * Contextual help bubble — shows a small (i) icon that reveals a tooltip on hover.
 * Usage: <HelpBubble tip="Explanation text here" />
 */
export function HelpBubble({ tip, side = "top", className = "" }) {
  if (!tip) return null;
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors focus:outline-none ${className}`} tabIndex={-1}>
            <Info size={13} />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-[280px] text-xs leading-relaxed font-normal">
          {tip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
